// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// breakpoint
	const breakpoint = window.matchMedia( 'screen and (min-width: 960px)' )

	// scroll volume
	function getScrolled() {
		return ( window.pageYOffset !== undefined ) ? window.pageYOffset: document.documentElement.scrollTop;
	}



	// variable
	// --------------------------------------------------------------- //

	// scroll
	let scrollTop = window.pageYOffset

	// url
	let url = location.href



	// Dropdown for mobile
	// --------------------------------------------------------------- //

	const dropDownButton = document.getElementById('js-mobile-menu');
	const menuOpenBackground = document.body;
	const navCloseButton = document.querySelector('.js-navigation-close button');
	const navigationBackground = document.querySelector('.site-navigation__background');

	function isMenuOpen() {
		return menuOpenBackground.classList.contains('is-menu-open');
	}

	function openMenu() {
		menuOpenBackground.classList.remove('is-menu-closing');
		dropDownButton.classList.add('is-close');
		menuOpenBackground.classList.add('is-menu-open');
	}

	function closeMenu() {
		if ( ! isMenuOpen() ) {
			return;
		}

		dropDownButton.classList.remove('is-close');

		// 閉じるアニメーション中の状態にする
		menuOpenBackground.classList.add('is-menu-closing');
		menuOpenBackground.classList.remove('is-menu-open');

		if ( navigationBackground ) {
			navigationBackground.addEventListener('transitionend', function handleTransitionEnd(e) {
				if ( e.propertyName !== 'transform' ) {
					return;
				}

				menuOpenBackground.classList.remove('is-menu-closing');
				navigationBackground.removeEventListener('transitionend', handleTransitionEnd);
			});
		}
	}

	function toggleMenu() {
		if ( isMenuOpen() ) {
			closeMenu();
			return;
		}

		openMenu();
	}

	if ( dropDownButton ) {
		dropDownButton.addEventListener('click', function(e) {
			e.preventDefault();
			toggleMenu();
		});
	}

	if ( navCloseButton ) {
		navCloseButton.addEventListener('click', function(e) {
			e.preventDefault();
			closeMenu();
		});
	}

	// ナビゲーション以外クリックで閉じる
	document.addEventListener('click', function(e) {
		if ( ! isMenuOpen() ) {
			return;
		}

		if ( dropDownButton && dropDownButton.contains(e.target) ) {
			return;
		}

		closeMenu();
	});

	// Escで閉じる
	document.addEventListener('keydown', function(e) {
		if ( ! isMenuOpen() ) {
			return;
		}

		if ( e.key === 'Escape' || e.key === 'Esc' ) {
			closeMenu();
		}
	});



	// Taxonomy Company Slider
	// --------------------------------------------------------------- //

	const swiper = new Swiper('.js-tax-company-swiper', {
		modules: [Autoplay, Navigation, Pagination],
		loop: true,
		slidesPerView: 1,
		autoplay: {
			delay: 2500, // 4秒ごとに切り替え（お好みで調整可）
			disableOnInteraction: false, // ユーザー操作後も自動再開したい場合
		},
		speed: 1000,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},

	});




	// Word Decoration
	// --------------------------------------------------------------- //

	const wordDecoration = document.querySelector('.word-decoration');
	const siteFooter = document.querySelector('.site-footer');
	const relatedArea = document.querySelector('div.wp-pattern-related-area');
	const isSinglePost = document.body.classList.contains('single-post');

	// single-post かつ related-area がある場合は related-area、
	// それ以外は site-footer を基準にする
	const wordDecorationStopTarget = isSinglePost && relatedArea
		? relatedArea
		: siteFooter;

	if (wordDecoration && wordDecorationStopTarget) {
		let ticking = false;

		// fixed時の値を最初に取得して保持
		const decorationTop = parseFloat(
			window.getComputedStyle(wordDecoration).top
		);
		const decorationHeight = wordDecoration.offsetHeight;
		const stopMargin = 32;

		const updateWordDecoration = () => {
			const targetTop = wordDecorationStopTarget.getBoundingClientRect().top;

			// fixed状態での.word-decorationの下端
			const decorationBottom = decorationTop + decorationHeight;

			if (targetTop <= decorationBottom + stopMargin) {
				wordDecoration.classList.add('is-hidden');
			} else {
				wordDecoration.classList.remove('is-hidden');
			}

			ticking = false;
		};

		const onScroll = () => {
			if (!ticking) {
				window.requestAnimationFrame(updateWordDecoration);
				ticking = true;
			}
		};

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll);

		updateWordDecoration();
	}



	const wordDecorationImages = document.querySelectorAll('.word-decoration__image');
	const queryEntryWrappers = document.querySelectorAll('.query-entry-wrapper');

	if (wordDecorationImages.length && queryEntryWrappers.length) {
		let currentCategory = 'sumau';
		let ticking = false;

		const changeDecoration = (category) => {
			if (currentCategory === category) {
				return;
			}

			currentCategory = category;

			wordDecorationImages.forEach((image) => {
				image.classList.toggle(
					'is-active',
					image.classList.contains(`is-${category}`)
				);
			});
		};

		const updateDecoration = () => {
			const triggerPosition = window.innerHeight * 0.5;
			let activeCategory = 'sumau';

			queryEntryWrappers.forEach((section) => {
				const rect = section.getBoundingClientRect();

				if (rect.top <= triggerPosition) {
					activeCategory = section.id;
				}
			});

			changeDecoration(activeCategory);

			ticking = false;
		};

		const onScroll = () => {
			if (!ticking) {
				window.requestAnimationFrame(updateDecoration);
				ticking = true;
			}
		};

		// 初期描画後からフェードを有効化
		window.requestAnimationFrame(() => {
			wordDecorationImages.forEach((image) => {
				image.classList.add('is-ready');
			});
		});

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll);

		updateDecoration();
	}

} );
